import { render, staticRenderFns } from "./CenterStructure.vue?vue&type=template&id=2af38e2e"
import script from "./CenterStructure.vue?vue&type=script&lang=js"
export * from "./CenterStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports